export default "__VITE_ASSET__a3aa9e58__"